import { Keys as u } from '../components/keyboard.js';
import { useEventListener as i } from './use-event-listener.js';
import { useIsTopLayer as f } from './use-is-top-layer.js';
function a(o) {
  let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typeof document != "undefined" ? document.defaultView : null;
  let t = arguments.length > 2 ? arguments[2] : undefined;
  let n = f(o, "escape");
  i(r, "keydown", e => {
    n && (e.defaultPrevented || e.key === u.Escape && t(e));
  });
}
export { a as useEscape };